<script setup lang="ts">
import {
  useFloating,
  autoPlacement,
  autoUpdate,
  offset,
  arrow,
  Placement,
} from "@floating-ui/vue";

const props = defineProps<{
  text?: string;
  label: HTMLElement;
  placement?: Placement;
  marginOffset?: number;
  allowedPlacements?: Placement[];
  disableTeleport?: boolean;
}>();

const floating = ref<HTMLDivElement>();
const arrowEl = ref<HTMLDivElement>();

const { floatingStyles, middlewareData } = useFloating(
  toRef(props.label),
  floating,
  {
    placement: props.placement || "top",
    middleware: [
      autoPlacement({
        allowedPlacements: props.allowedPlacements || [
          "top",
          "top-start",
          "top-end",
        ],
      }),
      offset(props.marginOffset || 5),
      arrow({ element: arrowEl, padding: 10 }),
    ],
    whileElementsMounted: autoUpdate,
  },
);
</script>

<template>
  <Teleport
    v-if="!disableTeleport"
    to="body"
  >
    <div
      ref="floating"
      class="floating"
      :style="floatingStyles"
    >
      <div
        v-if="placement === 'bottom'"
        ref="arrowEl"
        class="arrow-top"
        :style="{
          left:
            middlewareData.arrow?.x != null
              ? `${middlewareData.arrow.x}px`
              : '',
        }"
      ></div>
      {{ text }}
      <slot />
      <div
        v-if="placement === 'top'"
        ref="arrowEl"
        class="arrow-bottom"
        :style="{
          left:
            middlewareData.arrow?.x != null
              ? `${middlewareData.arrow.x}px`
              : '',
        }"
      ></div>
    </div>
  </Teleport>
  <div v-else>
    <div
      ref="floating"
      class="floating"
      :style="floatingStyles"
    >
      <div
        v-if="placement === 'bottom'"
        ref="arrowEl"
        class="arrow-top"
        :style="{
          left:
            middlewareData.arrow?.x != null
              ? `${middlewareData.arrow.x}px`
              : '',
        }"
      ></div>
      {{ text }}
      <slot />
      <div
        v-if="placement === 'top'"
        ref="arrowEl"
        class="arrow-bottom"
        :style="{
          left:
            middlewareData.arrow?.x != null
              ? `${middlewareData.arrow.x}px`
              : '',
        }"
      ></div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.arrow-bottom {
  @apply absolute -bottom-1 h-2 w-2 rotate-45 bg-blue-850;
}
.arrow-top {
  @apply absolute -top-1 h-2 w-2 rotate-45 bg-blue-850;
}

.floating {
  @apply absolute left-0 top-0 z-20 rounded-lg bg-blue-850 p-3 text-sm text-white;
  max-width: 300px;
}
</style>
